import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import Loading from "."
import useT from "utils/hooks/useT"

// RR5 P7: a brief full-screen loading overlay shown while a programmatic "open this analysis on the
// plan" navigation is in flight. limsReviews.openReviewAnalysis sets visual.activeAnalysisTaskId and
// jumps to the task's week; ScheduleElement clears the flag once the target task has rendered and
// opened. Jumping to an analysis in another week makes the plan screen fetch that week's schedule,
// which can take a moment with no feedback otherwise. Rendered at the app root so it survives the
// route change onto the plan, and reuses the shared .IapLoading overlay.
//
// A 250 ms show-delay avoids a flash when the target is already on screen (the flag clears almost
// immediately); a 12 s safety timeout hides the overlay if the task never renders, so it can never
// get stuck.
export default function AnalysisNavOverlay() {
  const { t } = useT("common")
  const pending = useSelector((state) => !!state.visual.activeAnalysisTaskId)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!pending) return undefined
    const showTimer = setTimeout(() => setReady(true), 250)
    const safetyTimer = setTimeout(() => setReady(false), 12000)
    return () => {
      clearTimeout(showTimer)
      clearTimeout(safetyTimer)
      setReady(false)
    }
  }, [pending])

  if (!pending || !ready) return null
  return (
    <div className="IapLoading">
      <Loading title={t("limsOpeningAnalysis")} />
    </div>
  )
}
